import { styled } from "styled-components";

export const HeaderComponent = styled.header`
  width: 100%;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #dfdfdf;
  box-sizing: border-box;
  background-color: #ffffff;
  z-index: 200;
  .inner {
    height: 100%;
  }
  @media all and (max-width: 1024px) {
    height: 80px;
  }
  @media all and (max-width: 900px) {
    display: none;
  }
`;

export const HeaderLogo = styled.h1`
  img {
    width: 170px;
    height: 60px;
  }
  @media all and (max-width: 900px) {
    width: 140px;
  }
  @media all and (max-width: 768px) {
    width: 19.531vw;
    img {
      width: 19.531vw;
      height: 6.771vw;
    }
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const HeaderNav = styled.nav`
  @media all and (max-width: 900px) {
    display: none;
  }
  ul {
    display: flex;
    align-items: center;
    gap: 80px;
    justify-content: flex-end;
    li {
      width: 142px;

      &.active {
        a {
          position: relative;
          color: #fbfbfb;
          &::after {
            content: "";
            display: block;
            width: calc(100% + 32px);
            height: calc(100% + 16px);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
            background-color: #233e99;
            border-radius: 20px;
          }
        }
      }
      a {
        font-size: 20px;
        line-height: 1.4;
        font-weight: 700;
        color: #171717;
      }
    }
  }
`;

export const HeaderSubNav = styled.nav<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? "158px" : "0")};
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};

  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  align-items: center;

  top: 100%;
  width: 100%;
  height: 160px;
  &::after {
    content: "";
    display: block;
    width: 100vw;
    height: 100%;
    background-color: blue;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #dfdfdf;
    background-color: rgba(255, 255, 255, 0.85);
  }
  > ul {
    display: flex;
    justify-content: flex-end;
    gap: 80px;
  }
  li {
    width: 142px;

    &.active {
      a {
        color: #233e99;
      }
    }
    a {
      font-size: 14px;
      line-height: 1.5;
      font-weight: 700;
      color: #6f6f6f;
      &:hover {
        color: #c1c1c1;
      }
    }
    > ul {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`;

export const HeaderMobComponent = styled.div`
  display: none;
  @media all and (max-width: 900px) {
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    left: 0;
    border-bottom: 1px solid #dfdfdf;
    box-sizing: border-box;
    background-color: #ffffff;
    z-index: 200;
    display: flex;
  }
  @media all and (max-width: 768px) {
    height: 60px;
  }
`;
export const HeaderMobContainer = styled.div`
  display: none;
  @media all and (max-width: 900px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

export const HeaderHamBugerWrap = styled.div`
  display: none;
  @media all and (max-width: 1024px) {
    cursor: pointer;
    width: 30px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    span {
      display: block;
      width: 30px;
      height: 2px;
      background-color: #171717;
    }
  }
  @media all and (max-width: 768px) {
    width: 5.208vw;
    gap: 0.781vw;
    span {
      width: 5.208vw;
      height: 0.391vw;
    }
  }
`;

export const HeaderMobNavDim = styled.div`
  display: block;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  left: 0;
  /* opacity: 1;
  visibility: visible; */
  z-index: 100;
  &.active {
    opacity: 1;
    visibility: visible;
  }
`;

export const HeaderMobLogo = styled.div`
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-end;
  i {
    display: block;
    width: 70%;
    img {
      width: 100%;
    }
  }
  @media all and (max-width: 768px) {
    margin-bottom: 6.51vw;
    i {
      width: 60%;
    }
  }
`;

export const HeaderMobNavWrap = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: -100%;
  z-index: 101;
  height: 100vh;
  transition: all 0.3s linear;
  &.active {
    right: 0;
  }
  @media all and (max-width: 1024px) {
    display: flex;
  }
`;

export const HeaderMobNavContentsWrap = styled.div`
  background-color: #fff;
  padding: 24px 20px;
  width: 40vw;
  @media all and (max-width: 768px) {
    width: 60vw;
    padding: 4.427vw 3.646vw;
  }
`;
export const HeaderMobNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  max-height: 65vh;
  overflow: scroll;
  > ul {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 24px;
    text-align: right;
    > li {
      display: flex;
      flex-direction: column;
      gap: 24px;
      &.active {
        > a {
          position: relative;
        }
      }
      a {
        color: #171717;
        font-weight: bold;
        font-size: 16px;
        /* font-family: "Pretendard"; */
        &:hover {
          color: #c1c1c1;
        }
      }
      > ul {
        display: flex;
        flex-direction: column;
        gap: 14px;
        li {
          &.active {
            a {
              color: #233e99;
            }
          }
          a {
            color: #6f6f6f;
          }
        }
      }
    }
  }
  > div {
    a {
      color: #c1c1c1;
      font-weight: bold;
      font-size: 16px;
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.646vw;
    > ul {
      gap: 3.646vw;
      > li {
        gap: 2.604vw;
        &.active {
          > a {
          }
        }
        > a {
          font-size: 3.385vw;
        }
        > ul {
          gap: 1.302vw;
          a {
            font-size: 3.125vw;
          }
        }
      }
    }
    > div {
      a {
        font-size: 3.385vw;
      }
    }
  }
`;
